import { Component, Input } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { DialogService } from '@ddt-web/dialog';

import { CustomizeAdvisoryFeeDialogComponent } from '../customize-advisory-fee-dialog/customize-advisory-fee-dialog.component';

@Component({
	selector: 'cfe-custom-advisory-fee-dialog-button',
	templateUrl: './custom-advisory-fee-dialog-button.component.html',
	styleUrls: ['./custom-advisory-fee-dialog-button.component.scss']
})
export class CustomAdvisoryFeeDialogButtonComponent {
	@Input() public customAdvisoryFee: number = 0;
	@Input() public showCurrentFee: boolean = false;
	@Input() public hideTooltip: boolean = false;
	@Input() public disableFeeExclusion: boolean = false;

	public isCustomFeeTooltipVisible: boolean = false;
	public showCustomFeeTooltip: boolean = true;

	constructor(public dialogService: DialogService, private contentService: ContentService) {
		this.showCustomFeeTooltip = !!this.contentService.get('CUSTOM_ADVISORY_FEE_TOOLTIP_CTA', 'Why Net Performance?').trim();
	}

	public openCustomAdvisoryFeeDialog(): void {
		this.dialogService.open(
			CustomizeAdvisoryFeeDialogComponent,
			{
				showClose: true,
				data: { closeAnalyticsEvent: 'customize advisory fee dialog:button:close', isEditMode: true, disableFeeExclusion: this.disableFeeExclusion }
			}
		);
	}
}
